var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.62988 10.88V5.46C7.62988 4.15 8.17987 2.86 9.23987 2.09C9.84987 1.65 10.5598 1.67 11.4598 1.67",
    stroke: "#EF5226",
    strokeWidth: 1.92,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23999 2.09C9.84999 1.65 10.56 1.67 11.46 1.67",
    stroke: "#EF5226",
    strokeWidth: 1.92,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2098 10.88V5.46C15.2098 4.15 14.6599 2.86 13.5999 2.09C12.9899 1.65 12.2799 1.67 11.3799 1.67",
    stroke: "#EF5226",
    strokeWidth: 1.92,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.55 24.69H6.29C3.34 24.69 1.05991 22.1 1.43991 19.17L2.46994 11.3C2.77994 8.86001 4.86002 7.04001 7.31002 7.04001H15.52C17.97 7.04001 20.05 8.86001 20.37 11.3L21.4 19.17C21.78 22.09 19.5 24.69 16.55 24.69Z",
    stroke: "#EF5226",
    strokeWidth: 1.92,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.e5bdf700f2ceaaaf98a4dc824b318c17.svg";
export { ForwardRef as ReactComponent };